var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5 10.5H4.703l5.449-6.54a1.499 1.499 0 10-2.304-1.92l-7.5 9c-.058.07-.088.153-.132.23-.036.064-.08.118-.106.187a1.478 1.478 0 00-.108.537L0 12l.002.006c0 .183.04.364.107.537.028.069.071.123.107.186.044.078.073.16.132.23l7.5 9a1.498 1.498 0 002.112.193c.636-.53.723-1.476.192-2.112l-5.45-6.54H22.5a1.5 1.5 0 000-3"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
